import { render, staticRenderFns } from "./email-admin.html?vue&type=template&id=72246230&scoped=true&external"
import script from "./email-admin.js?vue&type=script&lang=js&external"
export * from "./email-admin.js?vue&type=script&lang=js&external"
import style0 from "./email-admin.scss?vue&type=style&index=0&id=72246230&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72246230",
  null
  
)

export default component.exports